import MDButton from 'components/MDButton';
import React, { useEffect, useState } from 'react'
import { deleteFrequencyQuestions, getFrequencyQuestions, newFrequencyQuestions } from './../../api/routes';
import MDInput from 'components/MDInput';
import { Icon } from '@mui/material';
import { toast } from "react-toastify";

export default function FrequencyQuestions() {
    const [frequencyQuestions, setFrequencyQuestions] = useState([]);
    const [addFQ, setAddFQ] = useState(false);
    const [question, setQuestion] = useState();
    const [answer, setAnswer] = useState();

    useEffect(() => {
        getFrequencyQuestions((isOk, data) => {
            if (!isOk) return toast.error(data.message);
            else return setFrequencyQuestions(data)
        })
    }, [])
    const newFQ = () => {
        if (question && answer) {
            const data = {
                question,
                answer,
            }
            newFrequencyQuestions(data, (isOk, data) => {
                if (!isOk) return toast.error(data.message);

                else return window.location.reload()
            })
        }
    }

    const deleteFQ = (fqId) => {
        deleteFrequencyQuestions(fqId, (isOk, data) => {
            if (!isOk) return toast.error(data.message);

            else return window.location.reload()
        })
    }
    return (
        <div style={{ margin: '1rem 0' }}>
            {frequencyQuestions.map(fq => <section key={fq.frequencyQuestionsId} style={{ fontSize: '1rem', borderRadius: '8px', display: 'flex', flexDirection: 'column', minHeight: '60px', marginTop: '1rem', padding: '1rem', border: '1px solid #d2d6da' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <p style={{ color: '#00000099' }}>سوال : <span style={{ color: '#010101' }}>{fq.question}</span></p>
                    <MDButton variant="text" color="error" onClick={() => deleteFQ(fq.frequencyQuestionsId)}>
                        <Icon>delete</Icon>
                    </MDButton>
                </div>
                <p style={{ color: '#00000099', marginTop: '1rem' }}>جواب : <span style={{ color: '#010101', fontSize: '14px' }}>{fq.answer}</span></p>
            </section>)}
            <MDButton onClick={() => setAddFQ(true)} variant="gradient" color="info" sx={{ marginTop: '2rem' }}>
                افزودن سوالات متداول
            </MDButton>
            {addFQ && <>
                <hr style={{ width: '100%', margin: '2rem 0' }} />
                <MDInput type="text" label="سوال" value={question} onChange={(event) => setQuestion(event.target.value)} fullWidth />

                <MDInput multiline rows={5} type="text" value={answer} onChange={(event) => setAnswer(event.target.value)} label="جواب" fullWidth sx={{ marginTop: '1rem' }} />

                <MDButton onClick={newFQ} variant="gradient" color="info" sx={{ marginTop: '2rem' }}>
                    افزودن
                </MDButton>
            </>}
        </div>
    )
}
